import { Box, IconButton, Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export const BackButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '30px',
  left: '14px',
  zIndex: '1',

  [theme.breakpoints.down('sm')]: {
    left: '4px',
    top: '40px',
  },
}));

interface ModalProps {
  small?: number;
}

export const Dialog = styled(Box)<ModalProps>(({ theme, small }) => ({
  position: small ? 'relative' : 'static',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  maxWidth: small ? 560 : 700,
  width: small ? '100%' : '77%',
  maxHeight: '100%',
  padding: small ? '40px 60px' : '45px 60px 60px',
  overflow: 'auto',
  boxSizing: 'border-box',
  outline: 'none',
  background: 'rgba(255, 255, 255, 1)',

  [theme.breakpoints.down('md')]: {
    maxWidth: small ? 560 : 616,
    padding: small ? '40px 60px' : '45px 20px 60px',
  },

  [theme.breakpoints.down('sm')]: {
    position: 'relative',
    maxWidth: 'unset',
    width: small ? '90%' : '100%',
    padding: small ? '40px 20px 30px' : '74px 20px 60px',
  },
}));

interface TitleProps extends TypographyProps {
  small?: number;
}

export const Title = styled(Typography)<TitleProps>(({ theme, small }) => ({
  marginBottom: small ? '30px' : '25px',

  [theme.breakpoints.down('sm')]: {
    marginBottom: small ? '25px' : '15px',
  },
}));

export const CloseButton = styled(IconButton)(() => ({
  position: 'absolute',
  right: '15px',
  top: '15px',
}));
